import clsx from 'clsx';
import React from 'react';

export const CrmDetailWrapper = ({
  className,
  ...rest
}: React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>) => {
  return (
    <div
      className={clsx(
        'flex w-full items-center justify-start py-0 px-2 box-border border border-solid rounded min-h-[36px] relative',
        rest.onClick !== undefined &&
          'cursor-pointer hover:border-non-hover-border',
        className,
      )}
      {...rest}
    />
  );
};
